(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cozy-sounds"] && !Shopify.designMode) return;
  try {
    
const root=document.querySelector('.cs');
if(root){
 const audios=[...root.querySelectorAll('audio')];
 audios.forEach(a=>{a.volume=.2;a.addEventListener('play',()=>audios.forEach(other=>{if(other!==a)other.pause()}))});
 root.querySelectorAll('[data-cs-download]').forEach(a=>a.addEventListener('click',async e=>{
  e.preventDefault();if(a.getAttribute('aria-busy')==='true')return;
  const status=root.querySelector('[data-cs-status]');a.setAttribute('aria-busy','true');status.textContent=status.dataset.loading;
  try{const response=await fetch(a.href);if(!response.ok)throw new Error('download');const blob=await response.blob();const url=URL.createObjectURL(blob);const link=document.createElement('a');link.href=url;link.download=a.download;document.body.append(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(url),60000);status.textContent=status.dataset.done;}
  catch{status.textContent=status.dataset.error;window.open(a.href,'_blank','noopener');}
  finally{a.removeAttribute('aria-busy')}
 }));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
